import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight, Layers, Truck } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";

const AgencyBatchReceivedPage = () => {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const drops = parseInt(params.get("drops") || "0", 10);
  const total = parseFloat(params.get("total") || "0");
  return (
    <div className="App font-sans bg-white text-brand-charcoal antialiased">
      <Header />
      <main>
        <section className="pt-28 sm:pt-32 pb-24 bg-brand-cream min-h-[60vh] flex items-center">
          <div
            className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-10 text-center w-full"
            data-testid="batch-received-success"
          >
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-green/15 text-brand-green">
              <CheckCircle2 className="h-8 w-8" />
            </span>
            <h1 className="mt-6 font-display font-black text-3xl sm:text-4xl tracking-tight">
              Batch submitted.
            </h1>
            <p className="mt-3 text-[15px] text-brand-charcoal/70 leading-relaxed">
              Every drop-off is now an individual PO invoice in your account.
              Our team will confirm timing + routing within one business day.
            </p>
            {ref && (
              <p
                data-testid="batch-received-ref"
                className="mt-6 text-[11.5px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/55"
              >
                Reference: {ref}
              </p>
            )}
            <div className="mt-8 grid gap-3 sm:grid-cols-2 text-left">
              <div className="rounded-2xl bg-white border border-black/5 p-4">
                <div className="flex items-center gap-2 text-brand-teal">
                  <Layers className="h-4 w-4" />
                  <span className="text-[10.5px] font-bold uppercase tracking-[0.14em]">Drops</span>
                </div>
                <p className="mt-1.5 text-[22px] font-black tabular-nums">{drops}</p>
              </div>
              <div className="rounded-2xl bg-white border border-black/5 p-4">
                <div className="flex items-center gap-2 text-brand-gold-dark">
                  <Truck className="h-4 w-4" />
                  <span className="text-[10.5px] font-bold uppercase tracking-[0.14em]">
                    Batch total
                  </span>
                </div>
                <p className="mt-1.5 text-[22px] font-black tabular-nums">${total.toFixed(2)}</p>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/agency/batch"
                data-testid="batch-received-another"
                className="inline-flex items-center gap-2 rounded-full bg-brand-teal text-white px-5 py-3 text-[12px] font-bold uppercase tracking-[0.12em] hover:bg-brand-charcoal transition-colors"
              >
                Create another batch
              </Link>
              <Link
                to="/"
                data-testid="batch-received-home"
                className="inline-flex items-center gap-2 rounded-full bg-brand-charcoal text-white px-5 py-3 text-[12px] font-bold uppercase tracking-[0.12em] hover:bg-brand-teal transition-colors"
              >
                Back to Home <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default AgencyBatchReceivedPage;
